<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap">
  <!-- Contenet page started-->
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
    <div class="loader2"></div>
</div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="aqu-table-heading">

      </div>
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <ul class="breadcrumb">
          <li><a routerLink="/home">Summary View</a></li>
          <li><a>Devices List</a></li>
        </ul>
      </div>
      <!-- breadcrumb End -->
      <!-- START BASIC TABLE SAMPLE -->
      <div class="panel panel-default">
        <div class="panel-body table-responsive">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th>S.No</th>
              <th>DEVICE ID</th>
              <th>SERIAL NUMBER</th>
              <th>SALE TYPE</th>
              <th>MANUFACTURE DATE</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of samplingList | orderBy: key : reverse |  paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
              <td>{{((currentpagenum - 1) * noofitemsPerPage) + i + 1}}</td>
              <td>{{list.deviceNumber}}</td>
              <td>{{list.serialNumber}}</td>
              <td>{{list.saleType}}</td>
              <td>{{list.manufactured_date | date:"dd-MMM-yyyy"}}</td>
            </tr>
            </tbody>
          </table>
          <div class="dashboard-pagination-container" *ngIf="samplingList && samplingList.length > 0">
            <div class="items-per-page-block">
              <span class="items-per-page">Items per page</span>
              <div class="items-per-page-count-list form-field">
                <select class="form-control select" id="itemscount" autocomplete="off" (change)="noofitemsPerPage = $event.target.value;currentpagenum = 1;">
                  <option value="15" selected>15</option>
                  <option value="25" *ngIf="samplingList && samplingList.length > 15">25</option>
                  <option value="35" *ngIf="samplingList && samplingList.length > 25">35</option>
                  <option value="45" *ngIf="samplingList && samplingList.length > 35">45</option>
                </select>
                <span class="pagination-custom-down-arrow"></span>
              </div>
              <span class="items-per-page">1 - {{noofitemsPerPage}} of {{samplingList && samplingList.length}} items</span>
            </div>
            <div class="page-selection-div" *ngIf="noofitemsPerPage != samplingList.length">
              <pagination-controls (pageChange)="currentpagenum = $event" maxSize="5"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <!-- END BASIC TABLE SAMPLE -->
    </div>
  </div>
</div>
<!--  </div>
</div>-->
